// extracted by mini-css-extract-plugin
module.exports = {"content":"Toast_content__3xPcA","body":"Toast_body__3CR4h"};